import { Button3D } from "@/components/ui/button-3d";
import { AlertTriangle, RefreshCw } from "lucide-react";

export function ErrorFallback() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-background text-foreground text-center">
      <div className="max-w-md w-full space-y-6 bg-card p-8 rounded-2xl border border-border shadow-lg">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10 text-destructive">
          <AlertTriangle className="h-8 w-8" />
        </div>
        
        <div className="space-y-2">
          <h1 className="text-xl font-bold tracking-tight">Ops! Algo deu errado</h1>
          <p className="text-sm text-muted-foreground">
            Ocorreu um erro inesperado na aplicação. Nossa equipe foi notificada automaticamente.
          </p>
        </div>

        <Button3D
          onClick={handleReload}
          className="w-full gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Reiniciar aplicação
        </Button3D>
      </div>
    </div>
  );
}
